module.exports = __webpack_public_path__ + "img/social-shorts.ab19b8ab.webp";